import { CompanyState } from './types'
import { AsyncStateStatus } from '../root.types'
import { createSlice, Draft, PayloadAction } from '@reduxjs/toolkit'

const initialState: CompanyState = {
    request: {
        status: AsyncStateStatus.INITIAL,
        razaoSocial: '',
        data: []
    },
    describe: {
        status: AsyncStateStatus.INITIAL,
        razaoSocial: 'Carregando...',
        cnpj: 'Carregando...',
        companyDescribe: {
            status: AsyncStateStatus.INITIAL,
            data: []
        },
        companyConts: {
            status: AsyncStateStatus.INITIAL,
            data: []
        },
        companyAddress: {
            status: AsyncStateStatus.INITIAL,
            data: []
        },
        companyOwner: {
            status: AsyncStateStatus.INITIAL,
            data: []
        },
        companyAutos: {
            status: AsyncStateStatus.INITIAL,
            data: []
        },
        companyWorklist: {
            status: AsyncStateStatus.INITIAL,
            data: []
        },
        companyCounters: {
            status: AsyncStateStatus.INITIAL,
            data: []
        },
    }
}

export const companySlice = createSlice({
    name: '@company',
    initialState,
    reducers: {
        companyRequest: (state: Draft<CompanyState>) => {
            state.request.status = AsyncStateStatus.LOADING
        },
        companySuccess: (state: Draft<CompanyState>, action: PayloadAction<{ data: any }>) => {
            state.request.status = AsyncStateStatus.SUCCESS
            state.request.data = action.payload.data
        },
        companyFailure: (state: Draft<CompanyState>) => {
            state.request.status = AsyncStateStatus.FAILURE
        },
        describeRequest: (state: Draft<CompanyState>) => {
            state.describe.cnpj = initialState.describe.cnpj
            state.describe.razaoSocial = initialState.describe.razaoSocial
            state.describe.status = AsyncStateStatus.LOADING
            state.describe.companyDescribe.status = AsyncStateStatus.LOADING
            state.describe.companyConts.status = AsyncStateStatus.LOADING
            state.describe.companyAddress.status = AsyncStateStatus.LOADING
            state.describe.companyOwner.status = AsyncStateStatus.LOADING
            state.describe.companyAutos.status = AsyncStateStatus.LOADING
            state.describe.companyWorklist.status = AsyncStateStatus.LOADING
            state.describe.companyCounters.status = AsyncStateStatus.LOADING
        },
        describeSuccess: (state: Draft<CompanyState>, action: PayloadAction<{ data: any} >) => {
            state.describe.status = AsyncStateStatus.SUCCESS
            state.describe.razaoSocial = action.payload.data.razaoSocial
            state.describe.cnpj = action.payload.data.cnpj
            state.describe.companyDescribe.data = action.payload.data.companyDescribe
            state.describe.companyDescribe.status = AsyncStateStatus.SUCCESS
            state.describe.companyConts.status = AsyncStateStatus.SUCCESS
            state.describe.companyAddress.status = AsyncStateStatus.SUCCESS
            state.describe.companyOwner.status = AsyncStateStatus.SUCCESS
            state.describe.companyAutos.status = AsyncStateStatus.SUCCESS
            state.describe.companyWorklist.status = AsyncStateStatus.SUCCESS
            state.describe.companyCounters.status = AsyncStateStatus.SUCCESS
            state.describe.companyConts.data = action.payload.data.companyConts
            state.describe.companyAddress.data = action.payload.data.companyAddress
            state.describe.companyOwner.data = action.payload.data.companyOwner
            state.describe.companyAutos.data = action.payload.data.companyAutos
            state.describe.companyWorklist.data = action.payload.data.companyWorklist
            state.describe.companyCounters.data = action.payload.data.companyCounters
        },
        describeFailure: (state: Draft<CompanyState>, action: PayloadAction<{ data: any }>) => {
            state.describe.cnpj = action.payload.data.cnpj
            state.describe.razaoSocial = action.payload.data.razaoSocial
            state.describe.status = AsyncStateStatus.FAILURE
            state.describe.companyDescribe.status = AsyncStateStatus.FAILURE
            state.describe.companyConts.status = AsyncStateStatus.FAILURE
            state.describe.companyAddress.status = AsyncStateStatus.FAILURE
            state.describe.companyOwner.status = AsyncStateStatus.FAILURE
            state.describe.companyAutos.status = AsyncStateStatus.FAILURE
            state.describe.companyWorklist.status = AsyncStateStatus.FAILURE
            state.describe.companyCounters.status = AsyncStateStatus.FAILURE
        },
    }
})

/**
 * <h5>Functions that trigger actions related to authentication in the system.</h5>
 * @see {@link https://redux.js.org/tutorials/fundamentals/part-3-state-actions-reducers#designing-actions}
 * @typedef CompanyActions
 * @namespace CompanyActions
 * @category React
 * @subcategory Redux / Actions
 * @property {Function} companyRequest
 * @property {Function} companySuccess
 * @property {Function} companyFailure
 * @property {Function} describeRequest
 * @property {Function} describeSuccess
 * @property {Function} describeFailure
 */
export const CompanyActions = companySlice.actions

export default companySlice.reducer
